import React from 'react'
import { Svg, UserIcon, ga } from '../../application'
import { InviteUser } from './components'

const UserConnected = ({ onRevoke, ...user }) => (
  <InviteUser>
    <UserIcon accepted={user.invitationAccepted} {...user} />
    <div>
      <h4>{user.firstName}</h4>
      <div>{user.invitationEmail}</div>
    </div>
    <div onClick={(e) => {
      ga.buttonClick(`booking-invite-revoke-invite`)
      onRevoke(user.index)
    }}>
      <Svg icon="times" style={{ cursor: 'pointer' }} />
    </div>
  </InviteUser>
)

export default UserConnected